<template>
  <div id="q-app">
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      appear
      :duration="300"
    >
      <q-layout v-if="isBooting">
        <q-page-container>
          <q-page class="flex flex-center column">
            <q-spinner-puff
              color="primary"
              size="2em"
            />
          </q-page>
        </q-page-container>
      </q-layout>

      <router-view v-else />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState('application', ['language', 'config', 'isBooting']),
    ...mapState('vehicle', ['type']),
  },

  watch: {
    language() {
      this.$i18n.locale = this.language;
    },
  },

  async mounted() {
    // First we need to check if the kiosk is setup correctly.
    try {
      await this.loadConfig();

      // Switch to the location and get the products.
      await this.getProducts();

      if (!this.type) {
        // eslint-disable-next-line no-unused-vars
        this.$router.replace({ name: 'HomeScreen' }).catch(() => {});
      }
    }
    catch (e) {
      // console.log(e);
    }
    finally {
      this.bootComplete();
    }
  },

  methods: {
    ...mapMutations('application', ['bootComplete']),
    ...mapActions('application', ['loadConfig']),
    ...mapActions('product', ['getProducts']),
  },
};
</script>
